import Vue from 'vue';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';

let Slurp = window.slurp || {};
let inProduction = process.env.NODE_ENV === 'production';

if (inProduction) {
    Raven.config(
        'https://f7a508504ab044939eb999779bc0979f@sentry.teratotech.com/25',
    )
        .addPlugin(RavenVue, Vue)
        .install();

    if (Slurp.auth) {
        let user = Slurp.auth.user;
        let franchise = Slurp.auth.franchise;

        let ctx = {
            id: user.id,
            email: user.email,
            name: user.name,
        };

        if (!_.isNil(franchise)) {
            ctx.Franchise = `${franchise.name} (${franchise.id})`;
        }

        Raven.setUserContext(ctx);
    }
}
